import React, { useMemo, useEffect, useRef, useState } from "react";
import "../assets/css/home.css";

import logo from "../assets/img/logo.webp";
import logoWhite from "../assets/img/logo-white.webp";

const footerMenus = [
    {
        heading: "Explore ISBMU",
        links: [
            ["About the University", "/about-us"],
            ["Vision & Mission", "/vision-mission"],
            ["Leadership & Management", "/leadership-and-management"],
            ["Accreditations & Recognitions", "/accreditations-recognitions"],
            ["Awards & Achievements", "/awards"],
            ["Contact Us", "/contact-us"],
        ],
    },
    {
        heading: "Admissions",
        links: [
            ["Explore Programmes", "/programmes"],
            ["Admission Procedure", "/admission-procedure"],
            ["Eligibility Criteria", "/eligibility"],
            ["Scholarships", "/scholarships"],
            ["Apply Online", "/apply-online"],
            ["Pay Online", "/pay-online"],
            ["Download Prospectus", "/prospectus"],
        ],
    },
    {
        heading: "Academics & Research",
        links: [
            ["Schools & Faculties", "/schools"],
            ["Academic Calendar", "/academic-calendar"],
            ["Research & Development", "/research"],
            ["Ph.D. Research", "/phd-research"],
            ["IQAC", "/iqac"],
            ["e-Library", "/e-library"],
            ["International Relations", "/international"],
        ],
    },
    {
        heading: "Student Experience",
        links: [
            ["Campus Life", "/campus-life"],
            ["Facilities", "/facilities"],
            ["Hostel", "/hostel"],
            ["Events", "/events"],
            ["Alumni", "/alumni"],
            ["Placements", "/placements"],
            ["Student Login", "/student-login"],
        ],
    },
    {
        heading: "Essential Links",
        links: [
            ["Newsletters", "/newsletters"],
            ["Circulars & Notices", "/notices"],
            ["Anti-Ragging", "/anti-ragging"],
            ["Grievance Redressal", "/grievance-redressal"],
            ["Mandatory Disclosure", "/mandatory-disclosure"],
            ["Public Self Disclosure", "/public-self-disclosure"],
            ["RTI", "/rti"],
            ["Careers", "/careers"],
        ],
    },
];

function FooterLinkColumn({ menu }) {
    return (
        <div className="university-footer__column">
            <h3>{menu.heading}</h3>
            <ul>
                {menu.links.map(([label, link]) => (
                    <li key={label}>
                        <a href={link}>
                            {label}
                            <span>↗</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function Footer() {
    const [email, setEmail] = useState("");

    const submitNewsletter = (event) => {
        event.preventDefault();
        if (!email.trim()) return;
        setEmail("");
    };

    return (
        <footer className="university-footer">
            <div className="university-footer__cta">
                <div className="info-container">
                    <div>
                        <span>Your future begins here</span>
                        <h2>Ready to take the next step?</h2>
                    </div>
                    <div className="university-footer__cta-links">
                        <a href="/apply-online">
                            Apply Online <span>↗</span>
                        </a>
                        {/* <a href="/programmes">
                            Explore Programmes <span>↗</span>
                        </a> */}
                    </div>
                </div>
            </div>

            <div className="university-footer__main">
                <div className="info-container">
                    <div className="university-footer__brand-row">
                        <div className="university-footer__brand">
                            <a href="/" className="university-footer__logo">
                                <img src={logo} />
                            </a>
                            <p>
                                A multidisciplinary learning community committed to knowledge,
                                wisdom, humanity and future-ready education.
                            </p>
                        </div>
                        <div className="university-footer__contact-grid">
                            <div>
                                <small>Admissions helpline</small>
                                <a href="tel:+919373199999">+91-9373199999</a>
                            </div>
                            <div>
                                <small>Email us</small>
                                <a href="mailto:enquiry@isbmuniversity.edu.in">
                                    enquiry@isbmuniversity.edu.in
                                </a>
                            </div>
                            <div>
                                <small>Visit us</small>
                                <a href="/contact-us">Raipur, Chhattisgarh, India ↗</a>
                            </div>
                        </div>
                    </div>

                    <div className="university-footer__menus">
                        {footerMenus.map((menu) => (
                            <FooterLinkColumn key={menu.heading} menu={menu} />
                        ))}
                    </div>

                    <div className="university-footer__bottom">
                        <p>
                            © {new Date().getFullYear()} ISBM University. All rights reserved.
                        </p>
                        <div>
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/refund-policy">Refund Policy</a>
                            <a href="/terms-and-conditions">Terms & Conditions</a>
                            <a href="/sitemap">Sitemap</a>
                        </div>
                        <div className="university-footer__socials">
                            <a href="#facebook" aria-label="Facebook">
                                f
                            </a>
                            <a href="#instagram" aria-label="Instagram">
                                ◎
                            </a>
                            <a href="#linkedin" aria-label="LinkedIn">
                                in
                            </a>
                            <a href="#youtube" aria-label="YouTube">
                                ▶
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
